module.exports = __webpack_public_path__ + "img/ba.834689d8.svg";